export default {
    "graphqlEndpoint": "https://ebs43zgiqvgydiw4lh6zegx6mi.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "region": "ap-southeast-2",
    "authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "apiKey": "da2-6rlu2crexfagzgnus2vrh7en7y"
}


// WEBPACK FOOTER //
// ./src/AppSync.js